module.exports = __webpack_public_path__ + "static/media/GitHub-Mark.21c8725f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/GitHub-Mark.svg
// module id = 35
// module chunks = 0